import React from 'react';
import './HomeHero.css';
import { useTranslation } from 'react-i18next';

const HomeHero = ({ onOpenBalanceModal, onScrollToCases, onOpenFreeCase }) => {
  const { t } = useTranslation();

  return (
    <div className="home-hero-section">
      <div className="hero-main-content">
        <div className="hero-text-content">
          <h2>
            {t('hero_title_line1')}
            <br />
            {t('hero_title_line2')}
          </h2>
          <p>{t('hero_subtitle')}</p>
          <div className="hero-buttons">
            <button className="hero-btn primary" onClick={onOpenBalanceModal}>{t('hero_button_primary')}</button>
            <button className="hero-btn secondary" onClick={onScrollToCases}>{t('hero_button_secondary')}</button>
          </div>
        </div>
        <div className="hero-widgets">
          <div className="widget daily-bonus">
            <div className="widget-icon">🎁</div>
            <div className="widget-title">
              <span>{t('widget_daily_bonus')}</span>
              <span className="widget-status">{t('widget_status_available')}</span>
            </div>
          </div>
          <div className="widget free-case">
            <div className="widget-image-container">
              <div className="widget-image">
                <img src="/cases/free-case-card.png" alt={t('widget_free_case')} />
              </div>
              <span className="widget-free-case-text">{t('widget_free_case')}</span>
            </div>
            <button className="widget-pay-btn" onClick={onOpenFreeCase}>{t('widget_get_free')}</button>
          </div>
        </div>
      </div>
      <div className="stats-container">
        <div className="stat-card">
          <div className="stat-value-container">
            <span className="stat-value">1 250+</span>
          </div>
          <span className="stat-label">{t('stat_active_users')}</span>
        </div>
        <div className="stat-card">
          <div className="stat-value-container">
            <span className="stat-value">2 105+</span>
          </div>
          <span className="stat-label">{t('stat_cases_opened')}</span>
        </div>
        <div className="stat-card">
          <div className="stat-value-container">
            <span className="stat-value">100%</span>
          </div>
          <span className="stat-label">{t('stat_gifts_withdrawn')}</span>
        </div>
      </div>
    </div>
  );
};

export default HomeHero; 